import React, { SyntheticEvent } from 'react';
import { Link } from 'react-router-dom';

import { injectIntl, WrappedComponentProps } from '@kyruus/intl';
import {
  ListItem,
  ListItemButton,
  ListItemText,
  OpenInNewIcon
} from '../../styles';
import { messages } from '../../lib';

export interface ListItemButtonProps {
  component?: 'a' | 'button' | typeof Link;
  role?: 'link' | 'button';
  href?: string;
  id?: string;
  onClick: (e: SyntheticEvent) => void;
  target?: '_blank' | '_self';
  rel?: string;
  to?: string;
}

interface BaseCtaListItemProps {
  buttonProps?: ListItemButtonProps;
  isExternalLink: boolean;
  primaryText: string | React.ReactNode;
  secondaryText?: string | React.ReactNode;
}
type CtaListItemProps = BaseCtaListItemProps & WrappedComponentProps;

export const CtaListItemBase = injectIntl(
  ({
    intl,
    buttonProps,
    primaryText,
    secondaryText,
    isExternalLink
  }: CtaListItemProps) => {
    const externalLinkAriaLabel = intl.formatMessage(
      messages.externalLinkAriaLabel
    );
    return (
      <ListItem disablePadding={true} divider={true}>
        <ListItemButton {...buttonProps}>
          <ListItemText primary={primaryText} secondary={secondaryText} />
          {isExternalLink && (
            <OpenInNewIcon
              titleAccess={externalLinkAriaLabel}
              fontSize="large"
            />
          )}
        </ListItemButton>
      </ListItem>
    );
  }
);
